import React, { useEffect, Fragment, useState } from "react";
import {Flex } from "../../../../container-components";
import styled from "styled-components";
import { Typography } from "../../../../typo-components";
import {IconButton } from "../../../../element-components";
import * as _ from "lodash";

import { Menu } from "../../../Form/elements/FormControl/_elements";
import { getNestedData } from "../../../../util/accessors";
import { tableValueFormatter } from "../..";

const MenuButton = styled.button`
  outline: none;
  border: none;
  background: transparent;
  // box-shadow: 1px 17px 64px -29px rgba(127, 194, 255, 0.41);
  border-radius: 5px;
  height: 100px;

  max-width: 500px;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 5px 10px;
  margin 0 5px;
`;

const _createHeaders = ({ header }) => {
  let additionalHeaders = [];
  if (header.columns) {
    additionalHeaders = header.columns.reduce((acc, h) => {
      return acc.concat(_createHeaders({ header: h }));
    }, []);
  }
  return [header, ...additionalHeaders];
};

const TablePaginator = ({
  canNextPage,
  canPreviousPage,
  previousPage,
  nextPage,
  pageIndex,
  pageOptions,
  page,
  config,
  pageSize,
  isBottom,
  itemsCount,
  rows,
  gotoPage,
  sortBy,
  Headers,
}) => {
  const [componentConfig, setComponentConfig] = useState({
    menu: { anchorEl: null },
    mounted: false,
    pages: [],
  });
  const [allHeaders, setAllHeaders] = useState(
    Headers.reduce((acc, h) => {
      return acc.concat(_createHeaders({ header: h }));
    }, [])
  );

  useEffect(() => {
    const pageSize = config?.pageConfig?.size || 1000;
    const dataSize = rows.length;
    const pagesLength = Math.ceil(dataSize / pageSize);
    const pageLength = Math.ceil(dataSize / pagesLength);

    const pages = [];

    for (let i = 0; i < pagesLength; i++) {
      const currentDataIndex = pageLength * i;
      const lastPageDataIndex =
        rows.length <= currentDataIndex + pageLength
          ? rows.length - 1
          : currentDataIndex + pageLength;

      pages.push(rows.slice(currentDataIndex, lastPageDataIndex));
    }
    setComponentConfig({ ...componentConfig, mounted: true, pages });
  }, [rows.length, sortBy?.[0]?.id]);

  const handleClick = ({ cb }) => {
    cb();
    isBottom && window.scrollTo(0, 0);
  };

  const getValueAccessor = ({ original }) => {
    let pageAccessor = config.pageConfig?.accessor?.primary;
    let type = config.pageConfig?.accessor?.type || "string";
    let formatType = config.pageConfig?.accessor?.formatType;
    if (sortBy?.[0]?.id) {
      pageAccessor = sortBy[0].id;

      const header = allHeaders.find((header) => {
        return header?.accessor === pageAccessor;
      });

      if (header.type) {
        type = header.type;
        formatType = header.formatType;
      }
    }
    return tableValueFormatter({
      formatType,
      value: getNestedData({ object: original, path: pageAccessor }),
      type,
    });
  };

  return componentConfig.mounted &&
    config.pageConfig &&
    componentConfig.pages?.length > 1 ? (
    <Fragment>
      <Flex nowrap>
        {canPreviousPage ? (
          <IconButton
            color="tertiary"
            iconConfig={{
              provider: "material-icons",
              name: "keyboard_arrow_left",
            }}
            margin="0"
            onClick={() => handleClick({ cb: () => previousPage() })}
          />
        ) : (
          <div />
        )}
        <Flex
          style={{ width: "50%", height: "115px", margin: "20px 0" }}
          column
        >
          <MenuButton
            onClick={(e) =>
              setComponentConfig({
                ...componentConfig,
                menu: { anchorEl: e.currentTarget },
              })
            }
          >
            {page && page.length > 0 ? (
              <Fragment>
                {config.pageConfig?.accessor?.primary && (
                  <Typography
                    color="tertiary"
                    variant="t5"
                    margin="0"
                    textAlign="center"
                  >
                    {getValueAccessor({ original: page?.[0]?.original })} -{" "}
                    {getValueAccessor({
                      original: page?.[page.length - 1]?.original,
                    })}
                  </Typography>
                )}

                <Typography
                  color="tertiary"
                  variant="t6"
                  margin="0"
                  textAlign="center"
                >
                  <strong>
                    Page {pageIndex + 1} of {pageOptions.length}
                  </strong>
                </Typography>
              </Fragment>
            ) : (
              <Typography
                color="tertiary"
                variant="t6"
                style={{ textAlign: "center", alignSelf: "center" }}
              >
                <strong>No Results</strong>
              </Typography>
            )}
          </MenuButton>
          {componentConfig.menu.anchorEl && (
            <Menu
              anchorEl={componentConfig?.menu.anchorEl}
              open={Boolean(componentConfig?.menu.anchorEl)}
              options={
                componentConfig.pages.length > 1
                  ? componentConfig.pages.map((page, pagesIndex) => {
                    return `Page ${pagesIndex + 1} - ${getValueAccessor({
                      original: page?.[0]?.original,
                    })} - ${getValueAccessor({
                      original: page?.[page.length - 1]?.original,
                    })}`;
                  })
                  : []
              }
              name={"componentConfig"}
              onClose={() =>
                setComponentConfig({
                  ...componentConfig,
                  menu: { anchorEl: null },
                })
              }
              onChange={(e, d, f, optionIndex) => {
                gotoPage(optionIndex);
              }}
              optionsDisplayAccessor={null}
              optionsAccessor={null}
              value=""
              input={"select"}
              isFocused={false}
              optionsRefresher={null}
              variant={"public"}
              optionsMenuSelect={null}
              setValues={() => null}
              values={{}}
              onBlur={null}
            />
          )}
        </Flex>

        {canNextPage ? (
          <IconButton
            color="tertiary"
            iconConfig={{
              provider: "material-icons",
              name: "keyboard_arrow_right",
            }}
            margin="0"
            style={{ justifySelf: "flex-end" }}
            onClick={() => handleClick({ cb: () => nextPage() })}
          />
        ) : (
          <div />
        )}
      </Flex>
    </Fragment>
  ) : (
    <Fragment />
  );
};

export default TablePaginator;
